<template>
  <div class="form-container">
    <div class="form-container__row">
      <Input
        @value="setName"
        :label="formSettings.name_field.label"
        :placeholder="formSettings.name_field.placeholder"
        :error="this.name.error.length != 0"
        maxlength="50"
      />
    </div>
    <div class="form-container__row">
      <Input
        :label="formSettings.email_field.label"
        type="email"
        @value="setEmail"
        :placeholder="formSettings.email_field.placeholder"
        :error="this.email.error.length != 0"
        maxlength="50"
      />
    </div>

    <div class="form-container__row">
      <div class="form-container__col">
        <Select
          identifier="value"
          :options="formSettings.select_1.options"
          :label="formSettings.select_1.title"
          :placeholder="formSettings.select_1.placeholder"
          :searchable="false"
          :error="this.klase.error.length != 0"
          @value="setKlase"
        />
      </div>
    </div>
    <div class="form-container__row">
      <div class="form-container__col">
        <Select
          @value="setProgram"
          identifier="name"
          :options="allPrograms"
          :initial="resultProgramParsed"
          :placeholder="formSettings.select_2.placeholder"
          :error="this.program.error.length != 0"
          :label="formSettings.select_2.title"
        />
      </div>
    </div>

    <div class="form-container__row">
      <div class="form-container_col">
        <Checkbox
          v-bind:key="index.toString()"
          v-for="(item, index) in formSettings.optional_fields"
          :label="item.value"
          @value="setOptionalField"
        />
      </div>
    </div>
    <div class="form-container__row">
      <SimpleButton title="Registruotis" light @click="submitHandler" />
    </div>
    <Toast :message="toast" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { loadProgramData } from "@/utils";
import isEmail from "validator/lib/isEmail";
import { submitTest } from "@/api/submitData";
import { Routes } from "@/constants";

import { Input, Select, Checkbox } from "@/components/Inputs";
import SimpleButton from "@/components/SimpleButton";
import Toast from "@/components/Toast";

export default {
  name: "FormContainer",
  data() {
    return {
      name: {
        value: "",
        error: ""
      },
      email: {
        value: "",
        error: ""
      },
      klase: {
        value: "",
        error: ""
      },
      program: {
        value: "",
        error: ""
      },
      result: "",
      optional_fields: [],
      errors: [],
      toast: []
    };
  },
  components: {
    Input,
    Select,
    SimpleButton,
    Checkbox,
    Toast
  },
  computed: {
    ...mapState({
      allPrograms: state => state.allPrograms,
      formSettings: state => state.registrationFormSettings,
      resultProgram: state => state.resultProgram
    }),
    resultProgramParsed: function() {
      return loadProgramData(this.resultProgram);
    }
  },
  methods: {
    submitHandler: function() {
      const form = {
        vardas: this.name.value,
        email: this.email.value,
        klase: this.klase.value,
        testo_rezultatas: this.resultProgramParsed.name,
        dominanti_programa: this.program.value,
        pasirenkami_laukai: this.optional_fields.toString()
      };
      if (this.validateForm()) {
        if (process.env.NODE_ENV === "development") {
          console.table(form);
        }
        if (process.env.NODE_ENV === "production") {
          submitTest({ form });
        }
        this.$router.push(Routes.completion.path);
      }
    },
    validateForm: function() {
      this.errors = [];
      if (this.name.value == "") {
        this.name.error = this.formSettings.name_field.error_empty;
        this.errors.push(this.formSettings.name_field.error_empty);
      }

      if (this.email.value == "") {
        this.email.error = this.formSettings.email_field.error_empty;
        this.errors.push(this.formSettings.email_field.error_empty);
      }

      if (this.email.value !== "" && !isEmail(this.email.value)) {
        this.email.error = this.formSettings.email_field.error_invalid;
        this.errors.push(this.formSettings.email_field.error_invalid);
      }

      if (this.klase.value == "") {
        this.klase.error = this.formSettings.select_1.error_empty;
        this.errors.push(this.formSettings.select_1.error_empty);
      }

      if (this.program.value == "") {
        this.program.error = this.formSettings.select_2.error_empty;
        this.errors.push(this.formSettings.select_2.error_empty);
      }

      if (this.errors.length) {
        this.toast = this.errors;
        return false;
      }

      return true;
    },
    setName: function(val) {
      this.name.error = "";
      this.name.value = val;
    },
    setEmail: function(val) {
      this.email.error = "";
      this.email.value = val;
    },
    setKlase: function(val) {
      this.klase.error = "";
      this.klase.value = val;
    },
    setProgram: function(val) {
      this.program.error = "";
      this.program.value = val;
    },
    setOptionalField: function(state, value) {
      if (state) {
        this.optional_fields.push(value);
      } else if (!state) {
        const index = this.optional_fields.indexOf(value);
        this.optional_fields.splice(index, 1);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.form-container {
  display: flex;
  flex-direction: column;
  width: 100%;

  &__row {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-bottom: spacer("m");
    width: 100%;

    @include if-tablet {
      align-items: flex-start;
      flex-direction: row;
    }
  }

  &__col {
    flex-basis: 100%;
    width: 100%;

    &:not(:last-child) {
      margin-bottom: spacer("m");
    }

    @include if-tablet {
      flex-grow: 1;

      &:not(:last-child) {
        margin-right: spacer("l");
        margin-bottom: 0;
      }

      &.-forty {
        flex-shrink: 0;
        flex-basis: 40%;
      }
    }
  }
}
</style>
